import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSteps } from "react-step-builder";
import { ChevronBoldForwardIcon } from "@jti/brand-icons/chevron-bold-forward";
import Step from "./Step";
import styles from "./Stepper.module.scss";
const Stepper = ({ titles, children, canMoveToStep }) => {
    const { prev, current } = useSteps();
    const renderLastStep = (titles) => {
        var _a;
        if (titles[current]) {
            return (_jsxs("div", { className: styles.stepperMobileNext, children: [(_a = titles[current]) === null || _a === void 0 ? void 0 : _a.title, _jsx(ChevronBoldForwardIcon, { className: styles.icon })] }));
        }
        return null;
    };
    return (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { children: [_jsx("div", { className: styles.stepper, children: titles.map((t, i) => (_jsx(Step, { title: t.title, current: current, stepNumber: i + 1, handlePrev: prev, canAccessPrev: t.canAccessPrev, canMoveToStep: canMoveToStep }, t.title))) }), _jsxs("div", { className: styles.stepperMobileRow, children: [_jsx("div", { className: styles.stepperMobileCurrent, children: titles[current - 1].title }), renderLastStep(titles)] })] }), _jsx("div", { className: styles.stepper, children: children })] }));
};
export default Stepper;
